import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { keyOf, NameAndCreateDateFormatter, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, editAction, extraActions, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';
import { useGlobalStore } from '@Stores/global';

import BuilderFormatter from './BuilderFormatter';
import CategoriesFormatter from './CategoriesFormatter';
import CustomColumnsFormatter from './CustomColumnsFormatter';
import DeleteEntityWithReferences from './DeleteEntityWithReferences';
import DuplicateEntity from './DuplicateEntity';
import EditBuilderEntity from './EditBuilderEntity';
import MoveEntity from './MoveEntity';
import ShowContestEntity from './ShowContestEntity';

export default function useColumns() {
  const { content_type } = useParams()
  const { siteSettings: { useThemeConfig } } = useGlobalStore()

  const custom = useThemeConfig(`types.${content_type}.post.custom`)

  return useMemo(() => {
    const leftColumns = [
      defaultColumnId(),
      defaultColumn('title', 'Description', info => <NameAndCreateDateFormatter info={info} />, { size: 300 }),
      defaultColumn('slug', 'Slug', info => <TruncateWithTooltipFormatter info={info} />),
    ]

    const pageColumns = []
    if (content_type !== 'page') {
      pageColumns.push(
        column.accessor('tags', {
          header: 'Tags',
          cell: info => <CategoriesFormatter info={info} />,
          enableSorting: false,
        }),
      )
    }

    const customColumns = []
    if (custom !== undefined && custom !== null) {
      for (const field in custom) {
        if (custom[field] && custom[field].grid) {
          const column = column.accessor(`custom${field}`, {
            header: custom[field].name,
            cell: info => <CustomColumnsFormatter info={info} field={field} />,
            enableSorting: false,
          })
          customColumns.push(column)
        }
      }
    }

    const rightColumns = [
      column.accessor('cmsPostBuilder.meta', {
        header: 'DnD',
        cell: info => <BuilderFormatter info={info} />,
        enableSorting: false,
      }),
      defaultActiveColumn(),
      defaultActionsColumn(
        editAction,
        editBuilderAction,
        extraActions(
          deleteAction,
          duplicateAction,
          content_type === 'sweep' ? showContestAction : moveAction,
        ),
      ),
    ]

    return [...leftColumns, ...pageColumns, ...customColumns, ...rightColumns]
  }, [content_type, custom])
}
function deleteAction(info) {
  return <DeleteEntityWithReferences key={keyOf(info, 'delete')} info={info} />
}

function duplicateAction(info) {
  return <DuplicateEntity key={keyOf(info, 'duplicate')} info={info} />
}

function moveAction(info) {
  return <MoveEntity key={keyOf(info, 'move')} info={info} />
}

function showContestAction(info) {
  return <ShowContestEntity key={keyOf(info, 'show-contest')} info={info} />
}

function editBuilderAction(info) {
  return <EditBuilderEntity key={keyOf(info, 'edit-builder')} info={info} />
}
